<div class="whole-container">
    <div class="container generic-container">
        <div class="icon-header-container">
            <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
            <span class="header">
                {{ "notification.heading.notifications" | translate }} -
                <span class="notification-count" *ngIf="unreadNotificationCount">{{
                    "(" + unreadNotificationCount + ")"
                }}</span>
            </span>
        </div>

        <div class="select-all" *ngIf="notifications.length; else noNotificationsTemplate">
            <mat-checkbox
                *ngIf="notifications.length > 1"
                class="hidden-checkbox"
                [indeterminate]="isSomeSelected()"
                [checked]="isAllSelected()"
                (change)="toggleSelectAll($event)"
            >
            </mat-checkbox>
            <div class="header-btn-container">
                <app-button variant="hero" (onClick)="onSelectAllButtonClick()">
                    {{ isAllSelected() ? "Unselect All" : "Select All" }}
                </app-button>
                <app-button
                    variant="white"
                    buttonClass="shadow-btn"
                    (onClick)="deleteSelectedNotifications()"
                    [disabled]="selectedNotifications.size === 0"
                >
                    {{ "notification.button.deleteBtn" | translate }}
                </app-button>
            </div>
        </div>
        <mat-spinner *ngIf="loading" color="warn" class="loading-spinner" [diameter]="70"></mat-spinner>
        <div *ngIf="!loading && notifications.length; else noNotificationsTemplate">
            <div class="notification-wrapper" *ngFor="let notification of notifications">
                <div class="notification-item">
                    <mat-checkbox
                        class="notification-checkbox"
                        (change)="toggleSelectNotification(notification.id)"
                        [checked]="selectedNotifications.has(notification.id)"
                    ></mat-checkbox>
                    <div
                        class="notification-container"
                        [ngClass]="{
                            'notification-unviewed': !notification.isMessageViewed,
                            'notification-viewed': notification.isMessageViewed
                        }"
                    >
                        <!-- Only show the border line and main card when the notification type is "Mail" -->
                        <div
                            *ngIf="notification.type === mail.Mail; else noMailTemplate"
                            class="border-line"
                            [ngClass]="{
                                'notification-unviewed': !notification.isMessageViewed,
                                'notification-viewed': notification.isMessageViewed
                            }"
                        >
                            <div class="main-card">
                                <div class="left-section">
                                    <p>{{ notification.message }}</p>
                                    <p>{{ notification.createdAt | date: "MMM d yyyy, h:mm a" }}</p>
                                    <p
                                        *ngIf="notification.type === mail.Mail"
                                        (click)="openMailPopup(notification); markNotificationAsViewed(notification.id)"
                                        class="know-more-text"
                                    >
                                        Know More
                                    </p>
                                </div>
                                <div class="right-section">
                                    <app-button
                                        variant="ghost"
                                        size="icon"
                                        (onClick)="deleteNotification(notification.id)"
                                        class="favorite-button"
                                        buttonClass="favorite-button"
                                    >
                                        <mat-icon class="delete-icon" fontSet="material-icons-outlined"
                                            >delete</mat-icon
                                        >
                                    </app-button>
                                </div>
                            </div>
                        </div>

                        <!-- Template to be used when the notification type is not "Mail" -->
                        <ng-template #noMailTemplate>
                            <div
                                class="main-card"
                                [ngClass]="{
                                    'notification-unviewed': !notification.isMessageViewed,
                                    'notification-viewed': notification.isMessageViewed
                                }"
                            >
                                <div class="left-section">
                                    <p>{{ notification.message }}</p>
                                    <p>{{ notification.createdAt | date: "MMM d yyyy, h:mm a" }}</p>
                                    <p
                                        *ngIf="notification.type === mail.Mail"
                                        (click)="openMailPopup(notification)"
                                        class="know-more-text"
                                    >
                                        Know More
                                    </p>
                                </div>
                                <div class="right-section">
                                    <mat-icon class="delete-icon" (click)="deleteNotification(notification.id)">
                                        delete_outline
                                    </mat-icon>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Conditionally show the View More button if the notification type is 'Mail' -->
                    </div>
                </div>
            </div>

            <div class="view-more-btn-container">
                <button class="save-btn" *ngIf="showViewMoreButton()" mat-flat-button (click)="loadMoreNotifications()">
                    {{ "notification.button.viewMoreBtn" | translate }}
                </button>
            </div>
        </div>

        <ng-template #noNotificationsTemplate>
            <div class="no-notifications" *ngIf="!loading">
                <mat-icon
                    svgIcon="emptyNotification"
                    class="emptyNotificationIcon"
                    aria-hidden="false"
                    aria-label="Empty Notification"
                />
                <h2>{{ "notification.heading.emptyNotification" | translate }}</h2>
                <p>{{ "notification.message.notificationMessage" | translate }}</p>
                <button mat-flat-button class="save-btn" (click)="goToHomePage()">
                    {{ "notification.button.backToHomeBtn" | translate }}
                </button>
            </div>
        </ng-template>
    </div>
</div>
